import { Box } from "@mui/material";
import logo from "assets/logos/LogomarkBrandBlack.svg";
import { Sx } from "utils/sx";

const logoStyles: Sx = (theme) => ({
    height: theme.spacing(4),
});

export const BrandBlackLogo = () => {
    return (
        <Box component="img" sx={logoStyles} alt="Liveheats logo" src={logo} />
    );
};
